import { http } from '@/services/api/client';
import type {
  CreateTaskBatchPayload,
  CreateTaskBatchResult,
  QueryTasksParams,
  TaskDetail,
  TaskPageResult,
} from '@/types/task';

export async function fetchTasks(params: QueryTasksParams): Promise<TaskPageResult> {
  return http.get('/tasks', { params }) as Promise<TaskPageResult>;
}

export async function fetchProjectTasks(
  projectId: string,
  params: QueryTasksParams,
): Promise<TaskPageResult> {
  return http.get(`/projects/${projectId}/tasks`, { params }) as Promise<TaskPageResult>;
}

export async function fetchTask(id: string): Promise<TaskDetail> {
  return http.get(`/tasks/${id}`) as Promise<TaskDetail>;
}

export async function startTask(id: string): Promise<TaskDetail> {
  return http.post(`/tasks/${id}/start`) as Promise<TaskDetail>;
}

export async function completeTask(
  id: string,
  payload?: { completionNote?: string },
): Promise<TaskDetail> {
  return http.post(`/tasks/${id}/complete`, payload ?? {}) as Promise<TaskDetail>;
}

export async function createTaskBatch(
  payload: CreateTaskBatchPayload,
): Promise<CreateTaskBatchResult> {
  return http.post('/tasks/batch', payload) as Promise<CreateTaskBatchResult>;
}

export async function updateTaskProgress(
  id: string,
  progressContent: string,
): Promise<TaskDetail> {
  return http.post(`/tasks/${id}/progress`, { progressContent }) as Promise<TaskDetail>;
}

export async function verifyTask(
  id: string,
  payload: { result: 'COMPLETED' | 'INCOMPLETE'; note?: string },
): Promise<TaskDetail> {
  return http.post(`/tasks/${id}/verify`, payload) as Promise<TaskDetail>;
}
